export default "__VITE_ASSET__BwBozH80__"